import { T } from "react-translator-component";
import {
    FacebookIconSVG,
    InstagramIconSVG,
    SpotifyIconSVG,
    YouTubeIconSVG,
    TwitterXIconSVG, // Usamos TwitterXIconSVG si renombraste Twitter
    TikTokIconSVG
} from './SocialIcons'; // Por ejemplo, si tu archivo se llama SocialIcons.jsx


// Mapeo de códigos de redes sociales a sus respectivos íconos
const socialIconMap = {
    facebook: FacebookIconSVG,
    twitter: TwitterXIconSVG,
    instagram: InstagramIconSVG,
    spotify: SpotifyIconSVG,
    youtube: YouTubeIconSVG,
    tiktok: TikTokIconSVG
};
const SocialLinks = ({ socialMediaArray }) => {
    if (socialMediaArray) {
        let countSocialNetworks = 0
        Object.entries(socialMediaArray).map(([socialNetworkName, socialUrl]) => {
            if (socialUrl)
                countSocialNetworks++
        })
        if (countSocialNetworks == 0) {
            return null
        }
        return (

            <div className="social-links-container">
                <h6 className="general-subtitle">{T("hotel.social-networks")}</h6>
                <div>
                    {Object.entries(socialMediaArray).map(([socialNetworkName, socialUrl]) => {
                        const IconComponent = socialIconMap[socialNetworkName]; // Obtener el SVG de la constante
                        if (!IconComponent) {
                            console.warn(`Icono para "${socialNetworkName}" no encontrado.`);
                            return null; // No renderizar si no hay icono
                        }
                        if (socialUrl) {
                            return (
                                <a
                                    key={socialNetworkName}
                                    href={socialUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-link mr-3"
                                    title={socialUrl}
                                >
                                    {IconComponent}
                                </a>
                            );
                        } else {
                            return null;
                        }

                    })}
                </div>
            </div >

        );
    } else {
        return null
    }
};

export default SocialLinks;